import { StyledFormGroup } from "../styled-form-group";
import { TextArea } from "@blueprintjs/core";
import React from "react";
import { onChangeFactory } from "./helpers";
import "styled-components/macro";

export function NotesInput({
  value,
  onValueChange,
  activeField,
  setActiveField,
  height = "100px"
}) {
  return (
    <StyledFormGroup
      helperText="Help us understand your decision process"
      label="Notes"
      labelFor="notes"
      activeField={activeField}
    >
      <div
        className="bp3-input-group"
        // css={`
        //   flex: 1;
        // `}
      >
        <span className="bp3-icon bp3-icon-comment" />
        <TextArea
          data-testid="report_action_form__notes_input"
          name="notes"
          value={value}
          onChange={onChangeFactory(onValueChange)}
          onFocus={() => setActiveField("notes")}
          // growVertically
          css={`
            &&& {
              height: ${height};
            }
          `}
        />
      </div>
    </StyledFormGroup>
  );
}
